module.exports = {
  "country": "IE",
  "artist": "Niamh Kavanagh",
  "song": "In your Eyes",
  "year": "1993",
  "place": "1",
  "spotify": "7LBBL20GLOtjBJwxgVmzPK"
};